const FormResources = {

    form_data:{
        code:           '',
    },

    form_format:[
        {
            css_class:  'col-md-12',
            type:       'text',
            maxlength:  10,
            disabled:   false,
            step:       '',
            name:       'Code:',
            model_name: 'code',
            ref:        'code_input',
            ref_alt:    'code_input_alt',
            required:   true,
        },
    ],

    form_data_for_mail_inspection:{
        associate_id: [],
    },

    form_data_for_inspection_room_images:{
        new_inspection_room_images: [],
    },

    form_format_for_mail_inspection:[
        {
            css_class:  'col-md-6',
            type:       'infinite-scroll-list',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Associate(s):',
            model_name: 'associate_id',
            ref:        'associate_id_input',
            ref_alt:    'associate_id_input_alt',
            required:   false,
            search: false,
            parent_class: 'custom-control custom-checkbox w-100',
            input_type: 'checkbox',
            input_class: 'custom-control-input',
            label_input_class: 'custom-control-label reports__show-hide__label ml-2',
            placeholder: 'Select associate(s)',
            close_on_option: false,
            track_by: 'name',
            enable_check_all: true
        },
    ],

    form_format_for_inspection_room_images:[
        {
            css_class:          'col-md-12',
            type:               'file',
            maxlength:          5000,
            disabled:           false,
            step:               '',
            name:               'Images:',
            model_name:         'new_inspection_room_images',
            second_model_name:  'inspection_room_images',
            ref:                'new_inspection_room_images_input',
            ref_alt:            'new_inspection_room_images_input_alt',
            required:           false,
            multiple:           'multiple',
            style: 'margin-top: 0px; right: 0px !important;'
        },
    ],
    
    
}

export default FormResources;